/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addPartnerDetails, getPartnerLogos } from "../../../../redux/features/partner-logos/_partnerAction";
import useTranslate from "../../../hooks/useTranslate";
import { toast } from "react-toastify";

type Partner = {
  id: number;
  image: string;
  file?: File;
  createdAt?: string;
  isExisting?: boolean;
};

const PartnerUpload = () => {
  const dispatch: any = useDispatch();
  const data: any = useSelector((state: any) => state.logoList?.data) || [];
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(false);
  const t = useTranslate();

  useEffect(() => {
    let obj: any[] = [];
    if (data && data.length > 0) {
      data.forEach((item, idx) => {
        obj.push({
          id: idx,
          image: process.env.REACT_APP_FILE_URL + "images/" + item,
          isExisting: true,
        });
      });
    }
    setPartners(obj);
  }, [data]);

  useEffect(() => {
    dispatch(getPartnerLogos({ page: 1, limit: 10 }));
  }, []);

  const handleAddPartner = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const newPartners = Array.from(files).map((file, index) => ({
        id: partners.length + index + 1,
        image: URL.createObjectURL(file),
        file,
        isExisting: false,
      }));
      setPartners([...partners, ...newPartners]);
    }
  };

  const handleDeletePartner = (id: number) => {
    setPartners(partners.filter((p) => p.id !== id));
  };

  const handleUploadAll = async () => {
    if (partners.length === 0) {
      toast.error(t("NO_LOGO_TO_SAVE"));
      return;
    }

    const formData = new FormData();

    const existingImages = partners
      .filter((p) => p.isExisting)
      .map((p) => p.image.replace(process.env.REACT_APP_FILE_URL + "images/", ""));
    existingImages.forEach((img) => formData.append("existingImages[]", img));

    partners.forEach((partner) => {
      if (partner.file) {
        formData.append("images[]", partner.file);
      }
    });

    try {
      setLoading(true);
      const result: any = await dispatch(addPartnerDetails(formData));
      if (addPartnerDetails.fulfilled.match(result)) {
        toast.success("Logos saved successfully!");
        // Reload from API so UI shows persisted logos (not only local blob previews)
        dispatch(getPartnerLogos({ page: 1, limit: 10 }));
      } else {
        toast.error(t("SOMETHING_WENT_WRONG") || "Failed to save logos. Check AWS/S3 credentials.");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error(t("SOMETHING_WENT_WRONG") || "Failed to save logos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e5e5",
        borderRadius: "10px",
        padding: "20px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h5 style={{ marginBottom: "15px", fontWeight: "600" }}>Partner Logos</h5>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
          gap: "15px",
          flexGrow: 1,
          marginBottom: "20px",
        }}
      >
        {partners.map((partner) => (
          <div
            key={partner.id}
            style={{
              position: "relative",
              border: "1px solid #ddd",
              borderRadius: "8px",
              background: "#f9f9f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              height: "100px",
            }}
          >
            <img
              src={partner.image}
              alt="partner"
              style={{
                maxHeight: "80px",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
            <button
              onClick={() => handleDeletePartner(partner.id)}
              style={{
                position: "absolute",
                top: "-8px",
                right: "-8px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <i
                className="bi bi-x-circle-fill"
                style={{ color: "red", fontSize: "18px" }}
              ></i>
            </button>
          </div>
        ))}

        <label
          style={{
            border: "2px dashed #bbb",
            borderRadius: "8px",
            background: "#fafafa",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100px",
          }}
        >
          <i className="bi bi-plus-circle" style={{ fontSize: "32px", color: "#999" }}></i>
          <input
            type="file"
            accept="image/*"
            multiple
            style={{ display: "none" }}
            onChange={handleAddPartner}
          />
        </label>
      </div>

      <div style={{ textAlign: "center" }}>
        <Button variant="primary" onClick={handleUploadAll} disabled={loading}>
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> {t("SAVE_LOGOS")}
            </>
          ) : (
            t("SAVE_LOGOS")
          )}
        </Button>
      </div>
    </div>
  );
};

export default PartnerUpload;
